module.exports = __webpack_public_path__ + "static/media/studio-pro.f8a7418a.png";